// React
import React from 'react';
import { injectIntl } from 'react-intl';
import classNames from 'classnames';
// Styles
import useStyles from './CustomItemsFilterDrawer.styles';
// Components
import Conditional from './../conditional/Conditional';
import CustomCheckBoxGroup from './../custom-check-box-group/CustomCheckBoxGroup';
import CustomDrawer from './../custom-drawer/CustomDrawer';
import CustomRadioGroup from './../custom-radio-group';
import CustomButton from './../buttons/custom-button/CustomButton';

const CustomItemsFilterDrawer = ({
  children,
  classes,
  clearFilterButtonText,
  confirmButtonText,
  drawerTitle,
  filterTitle,
  intl: { formatMessage },
  items,
  listTitle,
  onApplyFilter,
  onClearFilter,
  onClose,
  onItemsSelectionChange,
  open,
  searchFieldPlaceHolder,
  selectedItems,
  showAllOption,
  unique,
}) => {
  const advancedFiltersTitle =
    drawerTitle ||
    formatMessage({
      id: 'global.advancedFilter',
    });

  confirmButtonText =
    confirmButtonText ||
    formatMessage({
      id: 'customItemsFilterDrawer.confirmButtonText',
    });

  clearFilterButtonText =
    clearFilterButtonText ||
    formatMessage({
      id: 'customItemsFilterDrawer.clearFilterButtonText',
    });

  filterTitle =
    filterTitle ||
    formatMessage({
      id: 'customItemsFilterDrawer.filterTitle',
    });

  listTitle =
    listTitle ||
    formatMessage({
      id: 'customItemsFilterDrawer.listTitle',
    });

  searchFieldPlaceHolder =
    searchFieldPlaceHolder ||
    formatMessage({
      id: 'customItemsFilterDrawer.searchFieldPlaceHolder',
    });

  const componentClasses = useStyles();

  const onChangeCheckBoxGroup = selectedItemIds => {
    onItemsSelectionChange(selectedItemIds);
    return;
  };
  const onChangeRadioGroup = selectedItemId => {
    onItemsSelectionChange([selectedItemId]);
    return;
  };

  return (
    <CustomDrawer open={open} onClose={onClose} title={advancedFiltersTitle}>
      <div className={componentClasses.drawerContent}>
        <div className={componentClasses.drawerBody}>
          <Conditional if={!unique}>
            <CustomCheckBoxGroup
              filterTitle={filterTitle}
              items={items}
              listTitle={listTitle}
              onChange={onChangeCheckBoxGroup}
              searchFieldPlaceHolder={searchFieldPlaceHolder}
              selectedItems={selectedItems}
              showAllOption={showAllOption}
            ></CustomCheckBoxGroup>
          </Conditional>
          <Conditional if={unique}>
            <CustomRadioGroup
              filterTitle={filterTitle}
              items={items}
              listTitle={listTitle}
              onChange={onChangeRadioGroup}
              searchFieldPlaceHolder={searchFieldPlaceHolder}
              selectedItem={selectedItems[0]}
            ></CustomRadioGroup>
          </Conditional>
        </div>
        {children}
        <div className={classNames(componentClasses.actionsContainer)}>
          <CustomButton
            classes={{ submitButton: componentClasses.clearFilterButton }}
            fullWidth={false}
            onClick={onClearFilter}
            text={clearFilterButtonText}
          ></CustomButton>
          <CustomButton
            classes={{ submitButton: componentClasses.applyButton }}
            color='primary'
            fullWidth={false}
            onClick={onApplyFilter}
            text={confirmButtonText}
            variant='outlined'
          ></CustomButton>
        </div>
      </div>
    </CustomDrawer>
  );
};

CustomItemsFilterDrawer.defaultProps = {
  classes: {},
  items: [],
  selectedItems: [],
  unique: false,
};

export default injectIntl(CustomItemsFilterDrawer);
